import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useCallback } from 'react';

/**
 *
 * A simple abstraction to play with a boolean value. It can be used to toggle a boolean value, set it to true or false.
 *
 */
function useBoolean(defaultValue) {
  var _useState = useState(!!defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var setTrue = useCallback(function () {
    return setValue(true);
  }, []);
  var setFalse = useCallback(function () {
    return setValue(false);
  }, []);
  var toggle = useCallback(function () {
    return setValue(function (x) {
      return !x;
    });
  }, []);
  return {
    value: value,
    setValue: setValue,
    setTrue: setTrue,
    setFalse: setFalse,
    toggle: toggle
  };
}

export { useBoolean };
